import { SendOutlined, DownloadOutlined, SaveOutlined, SearchOutlined, EditOutlined, ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Input, InputNumber, Row, Space, Tabs, Form, Select, DatePicker, Tag } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { dateCommon, formatVND, validateMessages } from '../../helpers/common';
import { ChiTietLuongThangItem, LuongThangInfo } from '../../models/luong/Luong';
import { DanhSachKhenThuongUngHoResponse } from '../../models/luong/Luong';
import {
    layDsKhenThuongUngHoTheoNam,
    layDsLuongCoBanTheoNam,
    layDsBangLuongPhuCapTheoNam,
    layDsLuongThemGioTheoNam,
    layDsLuongHoanThanhNhiemVuTheoNam,
    layDsLuongBoSungTruongBKSTheoNam,
    layDsPhuCapTGVTheoNam,
    layThongTinLuongThang,
    layChiTietLuongThang,
    taiLuongThang,
    luuLuongThang,
    duyetLuongThang,
    xacNhanTruocThueLuongThang,
    xacNhanThucNhanLuongThang,
    capNhatDuLieuThamChieuLuongThang,
    xuatExcelLuongThang,
    xoaBangLuong,
} from "../../services/luong";
import { hideLoadingScreen, showLoadingScreen } from "../../store/reducers/loading";
import { layDsThuLaoKCTTheoNam } from "../../services/thulaokhongchuyentrach";
import { layDanhSachKyThueKhongThuongXuyen, layDsThueThangTheoNam } from '../../services/thue';
import { Links } from '../../helpers/Links';
import TableChiTietLuongThang from '../../modules/salary/TableChiTietLuongThang';
import { useNavigate } from 'react-router-dom';

const QuanLyLuong = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [idLuong, setIdLuong] = useState<number>(0);
    const [luongThang, setLuongThang] = useState<LuongThangInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');
    const [isShowModalXacNhanTruocThue, setIsShowModalXacNhanTruocThue] = useState<boolean>(false);
    const [isShowModalXacNhanThucNhan, setIsShowModalXacNhanThucNhan] = useState<boolean>(false);
    const [isShowModalXoa, setIsShowModalXoa] = useState<boolean>(false);
    const [isShowModalCapNhatThamChieu, setIsShowModalCapNhatThamChieu] = useState<boolean>(false);

    const [danhSachNLD, setDanhSachNLD] = useState<ChiTietLuongThangItem[]>([]);
    const [danhSachChiTiet, setDanhSachChiTiet] = useState<ChiTietLuongThangItem[]>([]);
    const [reload, setReload] = useState<boolean>(false);

    // State ds thành phần cho modal cập nhật tham chiếu
    const [dsKhenThuongUngHo, setDsKhenThuongUngHo] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsLuongCoBan, setDsLuongCoBan] = useState<Array<any>>([]);
    const [dsLuongPhuCap, setDsLuongPhuCap] = useState<Array<any>>([]);
    const [dsLuongThemGio, setDsLuongThemGio] = useState<Array<any>>([]);
    const [dsLuongHTNV, setDsLuongHTNV] = useState<Array<any>>([]);
    const [dsLuongBSTBKS, setDsLuongBSTBKS] = useState<Array<any>>([]);
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsThueTNCN, setDsThueTNCN] = useState<Array<any>>([]);
    const [dsThueKTX, setDsThueKTX] = useState<Array<any>>([]);

    // State namLoc cho từng thành phần
    const [namLocKhenThuong, setNamLocKhenThuong] = useState<Dayjs | null>(null);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCap, setNamLocLuongPhuCap] = useState<Dayjs | null>(null);
    const [namLocLuongThemGio, setNamLocLuongThemGio] = useState<Dayjs | null>(null);
    const [namLocLuongHTNV, setNamLocLuongHTNV] = useState<Dayjs | null>(null);
    const [namLocLuongBSTBKS, setNamLocLuongBSTBKS] = useState<Dayjs | null>(null);
    const [namLocLuongThuLaoKCT, setNamLocLuongThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCapTGV, setNamLocLuongPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocThueTNCN, setNamLocThueTNCN] = useState<Dayjs | null>(null);
    const [namLocThueKTX, setNamLocThueKTX] = useState<Dayjs | null>(null);

    // State chế độ điều chỉnh
    // const [isEdit, setIsEdit] = useState<boolean>(false);
    // const [changedRowIds, setChangedRowIds] = useState<Set<number>>(new Set());

    const setChiTiet = (data: ChiTietLuongThangItem[]) => {
        setDanhSachChiTiet(data);
        setDanhSachNLD(data);
    };

    const layThongTin = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            const info = await layThongTinLuongThang(id);
            setLuongThang(info);
            const chiTiet = await layChiTietLuongThang(id);
            setChiTiet(chiTiet ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleTinhLuong = async () => {
        dispatch(showLoadingScreen());
        try {
            const data = await taiLuongThang(idLuong);
            setChiTiet(data ?? []);
            toast.success('Tính lương thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongThang({ id: idLuong, chiTiet: danhSachChiTiet });
            toast.success('Lưu lương thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXacNhanTruocThue = async () => {
        dispatch(showLoadingScreen());
        try {
            await xacNhanTruocThueLuongThang(idLuong);
            toast.success('Xác nhận trước thuế thành công');
            setIsShowModalXacNhanTruocThue(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXacNhanThucNhan = async () => {
        dispatch(showLoadingScreen());
        try {
            await xacNhanThucNhanLuongThang(idLuong);
            toast.success('Xác nhận thực nhận thành công (đã khóa bảng lương)');
            setIsShowModalXacNhanThucNhan(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        if (!idLuong || idLuong <= 0) return;
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuong(idLuong);
            toast.success('Xóa bảng tổng hợp lương thành công');
            navigate(Links.Luong.DanhSach);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXuatExcel = async () => {
        if (!idLuong) {
            toast.warning('Không tìm thấy thông tin lương');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const response = await xuatExcelLuongThang(idLuong);
            const fileName = `${luongThang?.tenKyLuong || 'BangTongHopThuNhap'}.xlsx`;
            const link = document.createElement('a');
            link.download = fileName;
            const blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error('Xuất file Excel không thành công. Vui lòng thử lại');
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    // const onChangeItem = (index: number, field: string, newValue: number) => {
    //     const updatedList = [...danhSachNLD];
    //     const row = { ...updatedList[index] };

    //     if (field === 'luongDuocNhan') {
    //         row.luongDuocNhan = newValue;
    //     }

    //     updatedList[index] = row;
    //     setDanhSachNLD(updatedList);

    //     const fullList = [...danhSachChiTiet];
    //     const chiTietIndex = fullList.findIndex(x => x.id === row.id);
    //     if (chiTietIndex >= 0) {
    //         fullList[chiTietIndex] = row;
    //         setDanhSachChiTiet(fullList);
    //     }

    //     setChangedRowIds(prev => {
    //         const newSet = new Set(prev);
    //         newSet.add(row.id);
    //         return newSet;
    //     });
    // };

    // const handleLuuDieuChinh = async () => {
    //     if (changedRowIds.size === 0) {
    //         toast.warning('Không có dữ liệu thay đổi!');
    //         return;
    //     }
    //     dispatch(showLoadingScreen());
    //     try {
    //         const changedItems = danhSachChiTiet
    //             .filter(x => changedRowIds.has(x.id))
    //             .map(x => ({
    //                 id: x.id,
    //                 luongDuocNhan: x.luongDuocNhan ?? 0,
    //             }));
    //         //await luuDieuChinhChiTietLuo({ items: changedItems });
    //         toast.success(`Lưu điều chỉnh thành công (${changedItems.length} dòng)`);
    //         setChangedRowIds(new Set());
    //         setIsEdit(false);
    //     } catch (err: any) {
    //         toast.error(err?.toString().replace('Error: ', ''));
    //     }
    //     dispatch(hideLoadingScreen());
    // };

    // Helper lấy ds từng thành phần theo năm
    const layDsThanhPhan = async (
        setFn: (data: any[]) => void,
        fetchFn: (nam?: number) => Promise<any[]>,
        nam?: number,
        filterFn?: (item: any) => boolean
    ) => {
        try {
            const data = await fetchFn(nam);
            const list = data ?? [];
            setFn(filterFn ? list.filter(filterFn) : list);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    // Helper tạo handler đổi năm lọc
    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        setFn: (data: any[]) => void,
        fetchFn: (nam?: number) => Promise<any[]>,
        filterFn?: (item: any) => boolean
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        form.setFieldsValue({ [fieldName]: [] });
        await layDsThanhPhan(setFn, fetchFn, date ? date.year() : undefined, filterFn);
    };

    const onMoModalCapNhatThamChieu = async () => {
        const hasAnySelected = [
            luongThang?.dsIdLuongKhenThuongUngHo,
            luongThang?.dsIdLuongCoBan,
            luongThang?.dsIdLuongPhuCap,
            luongThang?.dsIdLuongThemGio,
            luongThang?.dsIdLuongHTNV,
            luongThang?.dsIdLuongBSTBKS,
            luongThang?.dsIdLuongThuLaoKCT,
            luongThang?.dsIdLuongPhuCapTGV,
            luongThang?.dsIdThueTNCN,
            luongThang?.dsIdThueKTX,
        ].some(arr => (arr?.length ?? 0) > 0);

        const namMacDinh = hasAnySelected ? null : (luongThang?.thangNam ? dayjs(luongThang.thangNam) : dayjs());
        const getNamLoc = (ids?: number[]) => (ids && ids.length > 0 ? null : namMacDinh);

        const namKT = getNamLoc(luongThang?.dsIdLuongKhenThuongUngHo);
        const namLCB = getNamLoc(luongThang?.dsIdLuongCoBan);
        const namLPC = getNamLoc(luongThang?.dsIdLuongPhuCap);
        const namLTG = getNamLoc(luongThang?.dsIdLuongThemGio);
        const namHTNV = getNamLoc(luongThang?.dsIdLuongHTNV);
        const namBSTBKS = getNamLoc(luongThang?.dsIdLuongBSTBKS);
        const namTLKCT = getNamLoc(luongThang?.dsIdLuongThuLaoKCT);
        const namPCTGV = getNamLoc(luongThang?.dsIdLuongPhuCapTGV);
        const namTNCN = getNamLoc(luongThang?.dsIdThueTNCN);
        const namKTX = getNamLoc(luongThang?.dsIdThueKTX);

        setNamLocKhenThuong(namKT);
        setNamLocLuongCoBan(namLCB);
        setNamLocLuongPhuCap(namLPC);
        setNamLocLuongThemGio(namLTG);
        setNamLocLuongHTNV(namHTNV);
        setNamLocLuongBSTBKS(namBSTBKS);
        setNamLocLuongThuLaoKCT(namTLKCT);
        setNamLocLuongPhuCapTGV(namPCTGV);
        setNamLocThueTNCN(namTNCN);
        setNamLocThueKTX(namKTX);

        setIsShowModalCapNhatThamChieu(true);

        form.setFieldsValue({
            dot: luongThang?.dot ?? 1,
            tenKyLuong: luongThang?.tenKyLuong || (luongThang?.thangNam ? `BẢNG TỔNG HỢP THU NHẬP THÁNG ${dayjs(luongThang.thangNam).format('MM/YYYY')} - ĐỢT ${luongThang?.dot ?? 1}` : ''),
            ghiChu: luongThang?.ghiChu ?? '',
            dsIdLuongKhenThuongUngHo: luongThang?.dsIdLuongKhenThuongUngHo ?? [],
            dsIdLuongCoBan: luongThang?.dsIdLuongCoBan ?? [],
            dsIdLuongPhuCap: luongThang?.dsIdLuongPhuCap ?? [],
            dsIdLuongThemGio: luongThang?.dsIdLuongThemGio ?? [],
            dsIdLuongHTNV: luongThang?.dsIdLuongHTNV ?? [],
            dsIdLuongBSTBKS: luongThang?.dsIdLuongBSTBKS ?? [],
            dsIdLuongThuLaoKCT: luongThang?.dsIdLuongThuLaoKCT ?? [],
            dsIdLuongPhuCapTGV: luongThang?.dsIdLuongPhuCapTGV ?? [],
            dsIdThueTNCN: luongThang?.dsIdThueTNCN ?? [],
            dsIdThueKTX: luongThang?.dsIdThueKTX ?? [],
        });

        await Promise.all([
            layDsThanhPhan(setDsKhenThuongUngHo, layDsKhenThuongUngHoTheoNam, namKT ? namKT.year() : undefined, (x) => x.loaiUngHo !== 2),
            layDsThanhPhan(setDsLuongCoBan, layDsLuongCoBanTheoNam, namLCB ? namLCB.year() : undefined),
            layDsThanhPhan(setDsLuongPhuCap, layDsBangLuongPhuCapTheoNam, namLPC ? namLPC.year() : undefined),
            layDsThanhPhan(setDsLuongThemGio, layDsLuongThemGioTheoNam, namLTG ? namLTG.year() : undefined),
            layDsThanhPhan(setDsLuongHTNV, layDsLuongHoanThanhNhiemVuTheoNam, namHTNV ? namHTNV.year() : undefined),
            layDsThanhPhan(setDsLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam, namBSTBKS ? namBSTBKS.year() : undefined),
            layDsThanhPhan(setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam, namTLKCT ? namTLKCT.year() : undefined),
            layDsThanhPhan(setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam, namPCTGV ? namPCTGV.year() : undefined),
            layDsThanhPhan(setDsThueTNCN, layDsThueThangTheoNam, namTNCN ? namTNCN.year() : undefined),
            layDsThanhPhan(setDsThueKTX, (nam) => layDanhSachKyThueKhongThuongXuyen(nam ? nam.toString() : ""), namKTX ? namKTX.year() : undefined),
        ]);
    };

    const onChangeDotCapNhat = (val: number | null) => {
        if (!val) return;
        const currentTitle = form.getFieldValue('tenKyLuong');
        const thangNamStr = luongThang?.thangNam ? dayjs(luongThang.thangNam).format('MM/YYYY') : '';
        if (!currentTitle || currentTitle.includes('BẢNG TỔNG HỢP THU NHẬP THÁNG') || currentTitle.includes('Tổng hợp lương tháng')) {
            form.setFieldsValue({
                tenKyLuong: `BẢNG TỔNG HỢP THU NHẬP THÁNG ${thangNamStr} - ĐỢT ${val}`
            });
        }
    };

    useEffect(() => {
        if (isShowModalCapNhatThamChieu && luongThang) {
            form.setFieldsValue({
                dot: luongThang.dot ?? 1,
                tenKyLuong: luongThang.tenKyLuong || (luongThang.thangNam ? `BẢNG TỔNG HỢP THU NHẬP THÁNG ${dayjs(luongThang.thangNam).format('MM/YYYY')} - ĐỢT ${luongThang.dot ?? 1}` : ''),
                ghiChu: luongThang.ghiChu ?? '',
                dsIdLuongKhenThuongUngHo: luongThang.dsIdLuongKhenThuongUngHo ?? [],
                dsIdLuongCoBan: luongThang.dsIdLuongCoBan ?? [],
                dsIdLuongPhuCap: luongThang.dsIdLuongPhuCap ?? [],
                dsIdLuongThemGio: luongThang.dsIdLuongThemGio ?? [],
                dsIdLuongHTNV: luongThang.dsIdLuongHTNV ?? [],
                dsIdLuongBSTBKS: luongThang.dsIdLuongBSTBKS ?? [],
                dsIdLuongThuLaoKCT: luongThang.dsIdLuongThuLaoKCT ?? [],
                dsIdLuongPhuCapTGV: luongThang.dsIdLuongPhuCapTGV ?? [],
                dsIdThueTNCN: luongThang.dsIdThueTNCN ?? [],
                dsIdThueKTX: luongThang.dsIdThueKTX ?? [],
            });
        }
    }, [isShowModalCapNhatThamChieu, luongThang]);

    const onFinishCapNhatThamChieu = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const request = {
                id: idLuong,
                dot: values?.dot ?? 1,
                tenKyLuong: values?.tenKyLuong ?? '',
                ghiChu: values?.ghiChu ?? '',
                dsIdLuongKhenThuongUngHo: (values?.dsIdLuongKhenThuongUngHo ?? []) as number[],
                dsIdLuongCoBan: (values?.dsIdLuongCoBan ?? []) as number[],
                dsIdLuongPhuCap: (values?.dsIdLuongPhuCap ?? []) as number[],
                dsIdLuongThemGio: (values?.dsIdLuongThemGio ?? []) as number[],
                dsIdLuongHTNV: (values?.dsIdLuongHTNV ?? []) as number[],
                dsIdLuongBSTBKS: (values?.dsIdLuongBSTBKS ?? []) as number[],
                dsIdLuongThuLaoKCT: (values?.dsIdLuongThuLaoKCT ?? []) as number[],
                dsIdLuongPhuCapTGV: (values?.dsIdLuongPhuCapTGV ?? []) as number[],
                dsIdThueTNCN: (values?.dsIdThueTNCN ?? []) as number[],
                dsIdThueKTX: (values?.dsIdThueKTX ?? []) as number[],
            };
            await capNhatDuLieuThamChieuLuongThang(request);
            toast.success('Cập nhật dữ liệu thành công!');
            setIsShowModalCapNhatThamChieu(false);
            await layThongTin(idLuong);
            await handleTinhLuong();
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();
        setDanhSachNLD(
            danhSachChiTiet.filter(
                x => kw.length === 0 ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw)
            )
        );
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = parseInt(params.get('id') || '0');
        if (id > 0) setIdLuong(id);
    }, []);

    useEffect(() => {
        if (idLuong > 0) layThongTin(idLuong);
    }, [idLuong]);

    useEffect(() => {
        if (reload && idLuong > 0) {
            setReload(false);
            layThongTin(idLuong);
        }
    }, [reload]);

    const TRANG_THAI_LUONG = {
        KHOI_TAO: 0,
        XAC_NHAN_TRUOC_THUE: 1,
        XAC_NHAN_THUC_NHAN: 2,
    };

    const trangThaiLuong = luongThang?.trangThai ?? 0;
    const isKhoiTao = trangThaiLuong === TRANG_THAI_LUONG.KHOI_TAO;
    const isXacNhanTruocThue = trangThaiLuong === TRANG_THAI_LUONG.XAC_NHAN_TRUOC_THUE;
    const isXacNhanThucNhan = trangThaiLuong === TRANG_THAI_LUONG.XAC_NHAN_THUC_NHAN;
    const isKhoaToanBo = isXacNhanThucNhan;
    const isDaDuyet = isKhoaToanBo;
    const coDuLieuDaLuu = danhSachChiTiet.length > 0 && danhSachChiTiet.some(x => x.id > 0);
    const coTheDieuChinh = !isKhoaToanBo && coDuLieuDaLuu;
    const tongLuongDuocNhan = danhSachChiTiet.reduce((s, x) => s + (x.luongDuocNhan ?? 0), 0);

    // Helper render row chọn thành phần trong modal
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[],
        disabled?: boolean
    ) => (
        <Row gutter={8}>
            <Col span={8}>
                <Form.Item label={`Năm ${label}`}>
                    <DatePicker
                        changeOnBlur={true}
                        picker="year"
                        placeholder="Năm (để trống = tất cả)"
                        style={{ width: "100%" }}
                        value={namLoc}
                        onChange={onChangeNam}
                        disabled={disabled}
                    />
                </Form.Item>
            </Col>
            <Col span={16}>
                <Form.Item label={label} name={fieldName}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder={`Chọn ${label.toLowerCase()}`}
                        options={options}
                        disabled={disabled}
                        notFoundContent="Không có dữ liệu"
                        filterOption={(input, option: any) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
    );

    const demSoKhoan = (ids?: number[]) =>
        (ids?.length ?? 0) > 0 ? `${ids!.length} khoản` : 'Không có';

    return (
        <section>
            <ContentHeader title={luongThang?.tenKyLuong || `Tổng hợp lương tháng ${dateCommon.formatDate(luongThang?.thangNam, 'MM/yyyy')}`} />
            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Nhập tên, mã nhân viên"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={(e) => { if (e.key === 'Enter') search(); }}
                    />
                </Col>
                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>
                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>Tìm kiếm</Button>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" className="hrm-btn float-right hrm-btn-warning" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.Luong.DanhSach) }}>
                            Quay lại
                        </Button>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            className="hrm-btn hrm-btn-success"T
                            onClick={handleXuatExcel}
                        >
                            Xuất excel
                        </Button>
                        {!isKhoaToanBo && (
                            <Button type="primary" icon={<DownloadOutlined />} onClick={handleTinhLuong}>Tính lương</Button>
                        )}
                        {isKhoiTao && (
                            <Button
                                type="primary"
                                style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16' }}
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalXacNhanTruocThue(true)}
                            >
                                Xác nhận trước thuế
                            </Button>
                        )}
                        {!isKhoaToanBo && (
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalXacNhanThucNhan(true)}
                            >
                                Xác nhận thực nhận
                            </Button>
                        )}
                        {!isKhoaToanBo && (
                            <Button className="hrm-btn hrm-btn-warning" icon={<SaveOutlined />} onClick={handleLuu}>Lưu</Button>
                        )}
                        {isKhoiTao && (
                            <Button type="primary" danger icon={<DeleteOutlined />} onClick={() => setIsShowModalXoa(true)}>Xóa</Button>
                        )}
                    </Space>
                </Col>
            </Row>

            {/* Dữ liệu tham chiếu */}
            <Row gutter={8} className="form-group">
                <Col xs={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>Dữ liệu tham chiếu</div>
                            {!isKhoaToanBo && (
                                <Button type="primary" size="small" icon={<EditOutlined />} onClick={onMoModalCapNhatThamChieu}>
                                    Cập nhật
                                </Button>
                            )}
                        </div>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Tăng/Giảm</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongKhenThuongUngHo)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương cơ bản</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongCoBan)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Phụ cấp</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongPhuCap)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương thêm giờ</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongThemGio)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương HTNV</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongHTNV)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương bổ sung Trưởng BKS</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongBSTBKS)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Thù lao không chuyên trách</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongThuLaoKCT)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Phụ cấp tổ giúp việc</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(luongThang?.dsIdLuongPhuCapTGV)}</div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Box Ghi chú nếu có */}
            {luongThang?.ghiChu && (
                <Row gutter={8} className="form-group">
                    <Col xs={24}>
                        <div className="card" style={{ padding: '12px 16px', backgroundColor: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '4px' }}>
                            <div style={{ fontWeight: 'bold', color: '#0050b3', marginBottom: '4px' }}>Ghi chú:</div>
                            <div style={{ whiteSpace: 'pre-line', color: '#333' }}>{luongThang.ghiChu}</div>
                        </div>
                    </Col>
                </Row>
            )}

            {/* Thống kê tổng */}
            <Row gutter={8} className="form-group">
                <Col xs={24} sm={12} md={12}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Tổng lương được nhận</div>
                        <div className="text-bold text-center">{formatVND(tongLuongDuocNhan)}</div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Trạng thái</div>
                        <div className="text-bold text-center">
                            {isXacNhanThucNhan ? (
                                <span style={{ color: '#52c41a' }}>Đã xác nhận thực nhận</span>
                            ) : isXacNhanTruocThue ? (
                                <span style={{ color: '#fa8c16' }}>Đã xác nhận trước thuế</span>
                            ) : (
                                <span style={{ color: '#1890ff' }}>Khởi tạo (Chưa xác nhận)</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            // tabBarExtraContent={
                            //     <Space>
                            //         {coTheDieuChinh && (
                            //             <Button
                            //                 style={{ width: '140px' }}
                            //                 type="default"
                            //                 onClick={() => {
                            //                     if (isEdit && changedRowIds.size > 0) {
                            //                         layThongTin(idLuong);
                            //                         setChangedRowIds(new Set());
                            //                     }
                            //                     setIsEdit(!isEdit);
                            //                 }}
                            //                 icon={isEdit
                            //                     ? <LockOutlined style={{ color: 'red' }} />
                            //                     : <EditOutlined style={{ color: '#007bff' }} />
                            //                 }
                            //             >
                            //                 {isEdit ? 'Khóa' : 'Điều chỉnh'}
                            //             </Button>
                            //         )}
                            //         {isEdit && changedRowIds.size > 0 && (
                            //             <Button className="hrm-btn hrm-btn-warning" icon={<SaveOutlined />} onClick={handleLuuDieuChinh}>
                            //                 Lưu điều chỉnh ({changedRowIds.size})
                            //             </Button>
                            //         )}
                            //     </Space>
                            // }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: 'Bảng tổng hợp lương tháng',
                                    children: (
                                        <TableChiTietLuongThang
                                            dataSource={danhSachNLD}
                                            loading={loading}
                                            dynamicColumns={luongThang?.dynamicColumnHeaders}
                                            //isEdit={isEdit}
                                            //onChangeItem={onChangeItem}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>

            <ModalTextForm
                show={isShowModalXacNhanTruocThue}
                title="Xác nhận trước thuế bảng tổng hợp lương"
                handleClose={() => setIsShowModalXacNhanTruocThue(false)}
                handleSave={handleXacNhanTruocThue}
            >
                Bạn có chắc muốn <b>xác nhận trước thuế</b> cho bảng tổng hợp lương tháng{' '}
                {dateCommon.formatDate(luongThang?.thangNam, 'MM/yyyy')} không?
                <div className="text-danger mt-2 small font-italic">
                    * Lưu ý: Sau khi xác nhận trước thuế, các dữ liệu tham chiếu lương sẽ không thể chọn lại nữa.
                </div>
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalXacNhanThucNhan}
                title="Xác nhận thực nhận bảng tổng hợp lương"
                handleClose={() => setIsShowModalXacNhanThucNhan(false)}
                handleSave={handleXacNhanThucNhan}
            >
                Bạn có chắc muốn <b>xác nhận thực nhận</b> cho bảng tổng hợp lương tháng{' '}
                {dateCommon.formatDate(luongThang?.thangNam, 'MM/yyyy')} không?
                <div className="text-danger mt-2 small font-italic">
                    * Lưu ý: Sau khi xác nhận thực nhận, bảng lương sẽ chính thức <b>khóa toàn bộ</b> và không thể chỉnh sửa nữa.
                </div>
            </ModalTextForm>

            <ModalTextForm
                show={isShowModalXoa}
                title="Xác nhận xóa bảng tổng hợp lương"
                handleClose={() => setIsShowModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc muốn xóa bảng tổng hợp lương tháng{' '}
                {dateCommon.formatDate(luongThang?.thangNam, 'MM/yyyy')} không?
            </ModalTextForm>

            {isShowModalCapNhatThamChieu && (
                <ModalTextForm
                    title="Cập nhật dữ liệu tham chiếu"
                    hideFooter
                    dialogClassName="modal-75wh"
                    show={isShowModalCapNhatThamChieu}
                    handleClose={() => setIsShowModalCapNhatThamChieu(false)}
                >
                    <Form
                        key={`modal_form_${luongThang?.id}_${luongThang?.dot}_${isShowModalCapNhatThamChieu}`}
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinishCapNhatThamChieu}
                        form={form}
                        initialValues={{
                            dot: luongThang?.dot ?? 1,
                            tenKyLuong: luongThang?.tenKyLuong || (luongThang?.thangNam ? `BẢNG TỔNG HỢP THU NHẬP THÁNG ${dayjs(luongThang.thangNam).format('MM/YYYY')} - ĐỢT ${luongThang?.dot ?? 1}` : ''),
                            ghiChu: luongThang?.ghiChu ?? '',
                            dsIdLuongKhenThuongUngHo: luongThang?.dsIdLuongKhenThuongUngHo ?? [],
                            dsIdLuongCoBan: luongThang?.dsIdLuongCoBan ?? [],
                            dsIdLuongPhuCap: luongThang?.dsIdLuongPhuCap ?? [],
                            dsIdLuongThemGio: luongThang?.dsIdLuongThemGio ?? [],
                            dsIdLuongHTNV: luongThang?.dsIdLuongHTNV ?? [],
                            dsIdLuongBSTBKS: luongThang?.dsIdLuongBSTBKS ?? [],
                            dsIdLuongThuLaoKCT: luongThang?.dsIdLuongThuLaoKCT ?? [],
                            dsIdLuongPhuCapTGV: luongThang?.dsIdLuongPhuCapTGV ?? [],
                            dsIdThueTNCN: luongThang?.dsIdThueTNCN ?? [],
                            dsIdThueKTX: luongThang?.dsIdThueKTX ?? [],
                        }}
                    >
                        {isXacNhanTruocThue && (
                            <div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13px' }}>
                                <strong>Lưu ý:</strong> Bảng lương đã xác nhận trước thuế. Các khoản dữ liệu tham chiếu lương đã được cố định và không thể chọn lại (các khoản tham chiếu về thuế vẫn có thể chọn/điều chỉnh).
                            </div>
                        )}

                        <Row gutter={8}>
                            <Col span={6}>
                                <Form.Item label="Tháng chi trả">
                                    <Input
                                        disabled
                                        value={luongThang?.thangNam ? dateCommon.formatDate(luongThang.thangNam, 'MM/yyyy') : ''}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item rules={[{ required: true, message: 'Vui lòng nhập đợt' }]} label="Đợt" name="dot">
                                    <InputNumber min={1} style={{ width: "100%" }} placeholder="Đợt" onChange={onChangeDotCapNhat} />
                                </Form.Item>
                            </Col>
                            <Col span={14}>
                                <Form.Item rules={[{ required: true, message: 'Vui lòng nhập tên tiêu đề' }]} label="Tên tiêu đề kỳ lương" name="tenKyLuong">
                                    <Input placeholder="Nhập tên tiêu đề kỳ lương" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={24}>
                                <Form.Item label="Ghi chú" name="ghiChu">
                                    <Input.TextArea rows={3} placeholder="Nhập ghi chú (nếu có)" />
                                </Form.Item>
                            </Col>
                        </Row>

                        {renderThanhPhanRow("Tăng/Giảm", "dsIdLuongKhenThuongUngHo", namLocKhenThuong,
                            taoOnChangeNamLoc(setNamLocKhenThuong, "dsIdLuongKhenThuongUngHo", setDsKhenThuongUngHo, layDsKhenThuongUngHoTheoNam, (x) => x.loaiUngHo !== 2),
                            dsKhenThuongUngHo.filter(x => x.loaiUngHo !== 2).map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Lương cơ bản", "dsIdLuongCoBan", namLocLuongCoBan,
                            taoOnChangeNamLoc(setNamLocLuongCoBan, "dsIdLuongCoBan", setDsLuongCoBan, layDsLuongCoBanTheoNam),
                            dsLuongCoBan.map(x => ({ value: x.id, label: x.tenKyLuong })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Phụ cấp", "dsIdLuongPhuCap", namLocLuongPhuCap,
                            taoOnChangeNamLoc(setNamLocLuongPhuCap, "dsIdLuongPhuCap", setDsLuongPhuCap, layDsBangLuongPhuCapTheoNam),
                            dsLuongPhuCap.map(x => ({ value: x.id, label: x.tenKyLuong })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Lương thêm giờ", "dsIdLuongThemGio", namLocLuongThemGio,
                            taoOnChangeNamLoc(setNamLocLuongThemGio, "dsIdLuongThemGio", setDsLuongThemGio, layDsLuongThemGioTheoNam),
                            dsLuongThemGio.map(x => ({ value: x.id, label: x.tenKyLuong })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Lương HTNV", "dsIdLuongHTNV", namLocLuongHTNV,
                            taoOnChangeNamLoc(setNamLocLuongHTNV, "dsIdLuongHTNV", setDsLuongHTNV, layDsLuongHoanThanhNhiemVuTheoNam),
                            dsLuongHTNV.map(x => ({ value: x.id, label: x.tenKyLuong })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Lương Bổ sung Trưởng BKS", "dsIdLuongBSTBKS", namLocLuongBSTBKS,
                            taoOnChangeNamLoc(setNamLocLuongBSTBKS, "dsIdLuongBSTBKS", setDsLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam),
                            dsLuongBSTBKS.map(x => ({ value: x.id, label: x.tenKyLuong })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdLuongThuLaoKCT", namLocLuongThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocLuongThuLaoKCT, "dsIdLuongThuLaoKCT", setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam),
                            dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdLuongPhuCapTGV", namLocLuongPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocLuongPhuCapTGV, "dsIdLuongPhuCapTGV", setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam),
                            dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten })),
                            isXacNhanTruocThue
                        )}

                        {renderThanhPhanRow("Thuế TNCN (Thường xuyên)", "dsIdThueTNCN", namLocThueTNCN,
                            taoOnChangeNamLoc(setNamLocThueTNCN, "dsIdThueTNCN", setDsThueTNCN, layDsThueThangTheoNam),
                            dsThueTNCN.map(x => ({ value: x.id, label: x.tenKyThue || `Thuế TNCN tháng ${x.thang}/${x.nam}` })),
                            false
                        )}

                        {renderThanhPhanRow("Thuế KTX", "dsIdThueKTX", namLocThueKTX,
                            taoOnChangeNamLoc(setNamLocThueKTX, "dsIdThueKTX", setDsThueKTX, (nam) => layDanhSachKyThueKhongThuongXuyen(nam ? nam.toString() : "")),
                            dsThueKTX.map(x => ({ value: x.id, label: x.kyThue || `Thuế KTX ${x.loaiChuKy === 1 ? 'tháng ' + x.thang : 'quý ' + x.quy}/${x.nam}` })),
                            false
                        )}

                        <Form.Item>
                            <Button type="primary" className="float-right" htmlType="submit" icon={<SaveOutlined />}>
                                Cập nhật
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}
        </section>
    );
};

export default QuanLyLuong;